<template>
    <div>
        <b-card no-body class="page-card">
            <b-card-header class="mx-3 px-0">
                <i class="fa fa-align-justify"></i> {{ trans.title }}
            </b-card-header>
            <b-card-body class="p-0">

                <b-alert variant='default' class='mt-5 text-secondary text-center' v-if='isEmptyItemsList' show>Aktuálne nie je dostupná žiadna novinka.</b-alert>

                <b-list-group flush v-if='!isEmptyItemsList'>
                    <b-list-group-item v-for="item in items" v-bind:key="item.id" :class="{'active': isActive(item.id), 'px-3': true}">
                        <div class="list-header" :class="{'mb-0': compactView}">
                            <a :href="'/dashboard/article/'+item.id" class="btn btn-view btn-sm btn-primary"><i class="fa fa-eye"></i></a>
                            <a :href="'/dashboard/article/'+item.id" class="title">
                                <span>{{ item.title }}</span><span style="color:red" v-if="typeof seenLatestNews !== 'undefined' && typeof seenLatestNews[item.id] !== 'undefined' && !seenLatestNews[item.id]"> *</span><br>
                                <small>{{ item.dateFormatted }}</small>
                            </a>
                        </div>

                        <p v-if="!compactView" v-html="item.bodyShort"></p>
                    </b-list-group-item>
                </b-list-group>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'news',

        props: {
            'items': {
                type: Array
            },
            'trans': {
                type: Object
            },
            'seenLatestNews': {
                type: Object
            },
            'compactView': {
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            activeItem: {
                type: String,
                default: function() {
                    return "0";
                }
            },
        },

        created() {
        },

        data() {
            return {
                isEmptyItemsList: (this.items.length === 0)
            };
        },

        methods: {

            // TODO - use it or remove
            async fetchDetail(id) {
                this.loading = true;
                const response = await axios.get(`/dashboard/article/${id}`);
                this.showArticle = response.data;
                this.loading = false;
            },

            isActive(id)
            {
                return this.activeItem === id;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/dashboard/widgets/News.vue